import React from 'react';
import { Form, InputNumber, Button, Card, Input, Switch, Typography } from 'antd';

const { Text } = Typography;

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 8 },
};

const tailLayout = {
  wrapperCol: { offset: 8, span: 16 },
};

const GlobalConfigurationPage = () => {
  const onFinish = (values: any) => {
    console.log('Success:', values);
    // Here you would typically call an API to save the settings
  };

  return (
    <div>
      <Card title="System Default Settings">
        <Form
          {...layout}
          name="global-config"
          initialValues={{
            defaultMaxInstances: 5,
            defaultMaxTasksPerDay: 50,
            defaultDataRetention: 30,
            defaultTaskTimeout: 600,
          }}
          onFinish={onFinish}
        >
          <Form.Item label="Default Max Concurrent Instances" name="defaultMaxInstances">
            <InputNumber min={1} />
          </Form.Item>
          <Form.Item label="Default Max Tasks Per Day" name="defaultMaxTasksPerDay">
            <InputNumber min={1} />
          </Form.Item>
          <Form.Item label="Default Data Retention (days)" name="defaultDataRetention">
            <InputNumber min={1} />
          </Form.Item>
          <Form.Item label="Default Task Timeout (seconds)" name="defaultTaskTimeout">
            <InputNumber min={60} />
          </Form.Item>
        </Form>
      </Card>

      <Card title="Global Policies" style={{ marginTop: 16 }}>
        <Form {...layout} name="global-policies">
          <Form.Item label="Egress IP Address" name="egressIp">
            <Input placeholder="e.g., 203.0.113.5" />
          </Form.Item>
           <Form.Item label="Cold Storage Tier After (days)" name="coldStorageDays">
            <InputNumber min={30} />
          </Form.Item>
        </Form>
      </Card>

      <Card title="Global Feature Flags" style={{ marginTop: 16 }}>
        <Form {...layout} name="feature-flags" initialValues={{ enableDynamicDeshell: true, enableFunctionGraph: false }}>
            <Form.Item label="Dynamic De-shelling" name="enableDynamicDeshell" valuePropName="checked">
                <Switch />
            </Form.Item>
            <Form.Item label="Function Call Graphing" name="enableFunctionGraph" valuePropName="checked">
                <Switch />
            </Form.Item>
            <Form.Item label="Detailed Performance Monitoring" name="enablePerfMonitoring" valuePropName="checked">
                <Switch />
            </Form.Item>
            <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 8 }}>
                <Text type="secondary">
                    Changes to feature flags may require a restart of analysis services to take effect. 
                    Disabling a feature will prevent new analyses from using it.
                </Text>
            </Form.Item>
        </Form>
      </Card>
      
      <Form.Item {...tailLayout} style={{marginTop: 16}}>
        <Button type="primary" htmlType="submit">
          Save Changes
        </Button>
      </Form.Item>
    </div>
  );
};

export default GlobalConfigurationPage;
